// extracted by mini-css-extract-plugin
module.exports = {"categories":"Categories-module__categories___26fV8","low-priority":"Categories-module__low-priority___Jo3c8"};